module.exports = __webpack_public_path__ + "static/img/tjsp1.b58916b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/tjsp1.png
// module id = 388
// module chunks = 0